export default function Logo({ light = false, size = 40 }) {
  return (
    <span className="flex items-center gap-3" data-testid="logo">
      <img
        src="/logo-mark.png"
        alt=""
        aria-hidden="true"
        width={size}
        height={size}
        className={`shrink-0 rounded-xl object-cover ${
          light ? "bg-cream p-0.5" : ""
        }`}
        style={{ width: size, height: size }}
      />
      <span className="leading-none">
        <span
          className={`block text-xl font-semibold uppercase tracking-[0.16em] ${
            light ? "text-cream" : "text-olive"
          }`}
        >
          Toscana
        </span>
        <span
          className={`mt-1 block text-[9px] font-medium uppercase tracking-[0.3em] ${
            light ? "text-cream/60" : "text-olive-mid"
          }`}
        >
          Cocinas Integrales
        </span>
      </span>
    </span>
  );
}
